export default __webpack_public_path__ + "static/media/new-icon-appointment-fill.96403129.svg";